export default __webpack_public_path__ + "static/media/alert.d37bf7d8.svg";